import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p>© {new Date().getFullYear()} Ayelgum Handson. All rights reserved.</p>
        <p className="footer-sub">
          Engineering resilient software systems & architecting secure IT infrastructure.
        </p>
      </div>
    </footer>
  );
}

export default Footer;

